import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme)=>({
        rootBox: {
            '& .MuiButtonGroup-groupedHorizontal:not(:nth-of-type(3n))::after': {
                backgroundColor: theme.tokens.colors.original.brand.primary
            }
        },
        dialogPaper: {
            willChange: 'transform',
            '&, & *': {
                cursor: 'grab !important'
            },
            '&:active, &:active *': {
                cursor: 'grabbing !important'
            },
            '& .endOfContent.active, & .endOfContent.active *': {
                cursor: 'grabbing !important'
            }
        },
        document: {
            width: '100%',
            overflow: 'hidden',
            transform: 'translate3d(0,0,0)',
            canvas: {
                border: 'none',
                width: '100% !important',
                height: 'auto !important'
            }
        },
        root: {
            position: 'relative'
        },
        collapseWrapper: {
            position: 'relative'
        },
        image: {
            width: '100%',
            position: 'absolute',
            top: 0,
            left: 0
        },
        imageWrapper: {
            paddingTop: '150%'
        }
    }));
export { useStyles };
